module.exports = __webpack_public_path__ + "static/media/Lover Please Stay (ft Ben Sharkey).abb0063c.jpg";